<div class="notes" [formGroup]="form">
  <div class="notes-fields">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Giorni</mat-label>
      <input matInput formControlName="giorni">
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Orari</mat-label>
      <input matInput formControlName="orari">
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Contatto</mat-label>
      <input matInput formControlName="contatto">
    </mat-form-field>

    <mat-form-field class="notes-free text-area-custom" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Nota libera</mat-label>
      <textarea matInput rows="4" maxlength="65" placeholder="Inserisci una nota..." formControlName="notaLibera"></textarea>
      <mat-hint align="end">{{ form.controls.notaLibera.value.length }}/65 caratteri</mat-hint>
    </mat-form-field>
  </div>

  <div class="notes-toggles">
    <mat-slide-toggle formControlName="inBolla" labelPosition="before">Da mettere in bolla</mat-slide-toggle>
    <mat-slide-toggle formControlName="sponda" labelPosition="before">Sponda</mat-slide-toggle>
  </div>
</div>
